import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

const styles = theme => ({
  checkbox: {
    marginRight: 40,
    color: '#afafaf',
    '&$checked': {
      color: theme.palette.text.primary,
    },
  },
  listtext: {
    fontSize: '13px',
  },
  checked: {},
  root: {
    width: '100%',

    backgroundColor: theme.palette.background.paper,
  },
});

class Multiplechoice extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { classes, data } = this.props;
    const rawPrefillValue = data?.autoAnswer || data?.answer_data_default || '';
    const preselectedValues = typeof rawPrefillValue === 'object' ? '' : rawPrefillValue;
    // Handle both comma-separated string and array formats
    const selectedValues = Array.isArray(preselectedValues)
      ? preselectedValues
      : typeof preselectedValues === 'string' && preselectedValues
      ? preselectedValues
          .split(',')
          .map(v => v.trim())
          .filter(v => v)
      : [];

    try {
      return (
        <div className={classes.root}>
          <List component="nav">
            {data.answer_list.map((n, i) => {
              const isSelected = selectedValues.includes(n[1]) || selectedValues.includes(n[0]);
              return (
                <ListItem dense button key={i}>
                  <Checkbox
                    checked={isSelected}
                    classes={{
                      root: data.style || classes.checkbox,
                      checked: classes.checked,
                    }}
                  />

                  <div>
                    {/*<div style={{textAlign:'left',display:'inline'}}>*/}
                    {/*<ListItemText   primary={`${n[0]}:`} />*/}

                    {/*</div>*/}
                    <div style={{ textAlign: 'left', display: 'inline' }}>
                      <ListItemText
                        className={classes.listtext}
                        disableTypography={true}
                        primary={<p style={{ marginBottom: 0, fontWeight: 'normal' }}>{n[1]}</p>}
                      />
                    </div>
                  </div>
                </ListItem>
              );
            })}
          </List>
        </div>
      );
    } catch (e) {
      return <h5>Please specify answers in config </h5>;
    }
  }
}

Multiplechoice.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Multiplechoice);
